// extracted by mini-css-extract-plugin
export default {"text":"dashboard-button_text__cZXb0","dashboard-button":"dashboard-button_dashboard-button__bGGvZ"};